var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('img',{staticStyle:{"margin-bottom":"1rem","display":"block"},attrs:{"src":"/images/logo-login.png","alt":"Protrader Register"}})])
}]

export { render, staticRenderFns }